import { LocalParkingOutlined, Settings } from "@material-ui/icons"
import ListAlt from "@material-ui/icons/ListAlt"
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn"

export const getParkeySections = () => [
  {
    id: "parkey",
    items: [
      {
        id: "parkey_parking",
        title: "Parkey",
        icon: LocalParkingOutlined,
        href: "/parkey/parqueadero",
      },
      {
        id: "bitacora",
        title: "Bitácora Digital",
        icon: ListAlt,
        href: "/parkey/bitacoraParkey",
      },
      {
        id: "pagos",
        title: "Pagos",
        icon: MonetizationOnIcon,
        href: "/parkey/pagosParkey",
      },
      {
        id: "config",
        title: "Configuración",
        icon: Settings,
        href: "/parkey/configParkey",
      },
    ],
  },
]
